import axios from "axios";
import { getCustomAuthToken } from "../auth/tokenStore";
import { CONFIG } from "../constants";

const api = axios.create({
  baseURL: CONFIG.API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  async (config) => {
    const token = getCustomAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
